module.exports = __webpack_public_path__ + "img/check-white.635fee14.svg";